import React from "react"
import SchedulePage from ".."
import ScheduleHeader from "../Header"
import OurService from "../OurService"
import LocationService from "../Service"
import ModuleTitle from "../../../atoms/SchedulePages/ModuleTitle"
import { PickupLocations, PickupLocation } from "../Locations"
import { Schedule, ScheduleTable } from "../ScheduleTable.jsx"
import Search from "../../HomePage/Search"

import Pickup_Locations from "./pickup-locations"
import { FortCollinsMeta, FortCollinsService, DropOffData } from "./metadata"
import VisitingFortCollins from "./Visiting"
import FortCollinsData from "./schedule"
import Seo from "../../../molecules/Seo"

import { MdAirlineSeatReclineExtra } from "@react-icons/all-files/md/MdAirlineSeatReclineExtra"
import { TbCalendarTime } from "react-icons/tb"
import { FaMapMarkerAlt } from "react-icons/fa"
import { FaHotel } from "react-icons/fa"

import "./fortCollins.scss"
import ScheduleNavigation from "../Navigation.jsx"

const FortCollinsNavigation = () => {

  const items = [
    {
      icon: <TbCalendarTime />,
      title: "Schedules",
      scrollTo: "schedules-module",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Pick-Up Locations",
      scrollTo: "pickup-locations",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Drop Off Locations",
      scrollTo: "drop-off-location-module",
    },
    {
      icon: <MdAirlineSeatReclineExtra />,
      title: "Our Service",
      scrollTo: "our-service-module",
    },
    {
      icon: <FaHotel />,
      title: "Visiting Fort Collins",
      scrollTo: "visiting-fort-collins-module",
    },
  ]

  return (
    <ScheduleNavigation items={items} />
  )
  
}

const FortCollinsSchedule = ({ history }) => {
  return (
    <SchedulePage>
      <Seo
        title={FortCollinsMeta.seo.title}
        description={FortCollinsMeta.seo.description}
        canonicalUrl={"https://landline.com/fort-collins"}
      />
      <section className="full-width-heading schedule-page-banner">
        <h1>Fort Collins to Denver (DIA) Airport Shuttle</h1>
        <span>Fort Collins | Loveland | Timnath | Wellington | Windsor</span>
      </section>
      <div className="schedule-search-form">
        <Search
          history={history}
          remoteCallSearchComponent={true}
          containerClassName="schedule-page-search-bg"
        />
      </div>
      <div className="schedule-page">
        <ScheduleHeader metadata={FortCollinsMeta.header} />

        <FortCollinsNavigation />

        <ModuleTitle title="Schedules" navigationid="schedules-module" />
        <Schedule>
          <ScheduleTable schedule={FortCollinsData.to} />
          <ScheduleTable schedule={FortCollinsData.from} />
        </Schedule>

        <PickupLocations>
          {Pickup_Locations.map(location => {
            return <PickupLocation location={location} />
          })}
        </PickupLocations>

        <section>
          <ModuleTitle title="Drop Off Location" navigationid="drop-off-location-module" />
          <LocationService service={DropOffData} />
        </section>

        <section>
          <ModuleTitle title="Our Service" navigationid="our-service-module" />
          <OurService service={FortCollinsService} />
        </section>

        <section>
          <ModuleTitle title="Visiting Fort Collins" navigationid="visiting-fort-collins-module" />
          <VisitingFortCollins />
        </section>
      </div>
    </SchedulePage>
  )
}

export default FortCollinsSchedule
